@if (code && !codelist) {
    <span>
        <span class="fi" [ngClass]="'fi-' + getCountry()"></span>
    </span>
}
@if (code && codelist) {
    <span>
        <span class="fi" [ngClass]="'fi-' + getCountry()"></span>
        <span>&nbsp;</span>
        <span>{{ code | codelist: '' + codelist | async }}</span>
    </span>
}
@if (!code) {
    <span>---</span>
}
